function guest_Reducer(state = [], action) {
    switch (action.type) {
        case 'GUEST/SET':            
            return action.guest;
        case 'GUEST/CLEAR':
            return null;
        default:
            return state;
    }
}

export default guest_Reducer;
